<template>
    <div class="card">
        <div class="card-header bg-primary text-white">Plantillas</div>
        <div class="card-body table-responsive">
            <table class="table table-hover table-sm">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Título</th>
                        <th>Dependencia</th>
                        <th>Organización</th>
                        <th>Archivos</th>
                        <th>Imagen</th>
                        <th>Audio</th>
                        <th>Video</th>
                        <th>Usuarios</th>
                        <th>Campos</th>
                        <td>Editar</td>
                        <th v-if="actions">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="format in formats" :key="format.id">
                        <td>{{format.name}}</td>
                        <td>{{format.title}}</td>
                        <td>{{format.entity}}</td>
                        <td>{{format.city}}</td>
                        <td>{{format.files}}</td>
                        <td>{{format.image ? 'Sí' : 'No'}}</td>
                        <td>{{format.audio ? 'Sí' : 'No'}}</td>
                        <td>{{format.video ? 'Sí' : 'No'}}</td>
                        <td>
                            <span class="badge badge-info mr-1" v-for="user in format.users" :key="user.id">{{user.last_name}} {{user.first_name}}</span>
                        </td>
                        <td>
                            <span class="badge badge-warning mr-1" v-for="field in format.fields" :key="field.id">{{field.name}}</span>
                        </td>
                        <td><a href="#" class="btn btn-warning btn-sm" @click.prevent="$emit('edit', format)"><i class="fa fa-edit"></i></a></td>
                        <td v-if="actions">
                            <a :href="getUrl(format.id)" class="btn btn-sm btn-success m-0 py-0">Formato <i class="fas fa-file-excel"></i></a>
                            <router-link class="btn ml-1 btn-sm btn-warning m-0 py-0" :to="{name: 'entity-format-records', params: {id: format.id}}"> <i class="fas fa-eye"></i> </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormatList",
    props: {
        formats: {
            type: Array,
            required: true,
        },
        actions: {
            type: Boolean,
            default: false
        }
    }, methods: {
        getUrl(id){
            return process.env.VUE_APP_API+'/entity/formats/'+id+'?token='+localStorage.getItem('session_id');
        },
    }
}
</script>

<style>

</style>